import { render, staticRenderFns } from "./perfilUserMobile.vue?vue&type=template&id=213e81f1&scoped=true&"
import script from "./perfilUserMobile.vue?vue&type=script&lang=js&"
export * from "./perfilUserMobile.vue?vue&type=script&lang=js&"
import style0 from "./perfilUserMobile.vue?vue&type=style&index=0&id=213e81f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e81f1",
  null
  
)

export default component.exports